//
// Module for the security model page in the Security section
//
rs.module("ui/security/development/securitymodel",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, formActionUrls, securityModelControl) {

            var form = $.js(jsSelectors.form);
            var scrollContainer = form.js(jsSelectors.scrollContainer);

            var scrollTopHidden = form.js(jsSelectors.scrollTopHidden);
            var scrollLeftHidden = form.js(jsSelectors.scrollLeftHidden);

            // Scroll the security model container vertically to the position it was before a post
            if (scrollTopHidden.val()) {

                var scrollTopPosition = scrollTopHidden.val();

                var nodeDOMRect = securityModelControl.getSelectedNodeDOM()[0].getBoundingClientRect();
                var scrollContainerDOMRect = scrollContainer[0].getBoundingClientRect();

                // Calcluate the position of the node as if the container was scrolled
                // At this point we havent scrolled the container, so nodeDOMRect.top is going to give us the nodes position like the container was scrolled to 0.
                // We need to adjust that for the previous scroll position.
                var nodeTopPosition = nodeDOMRect.top - scrollTopPosition;
                var nodeBottomPosition = nodeDOMRect.bottom - scrollTopPosition;

                // Check if the node is off screen vertically, if so adjust the scroll position
                if (nodeTopPosition < scrollContainerDOMRect.top) {

                    scrollTopPosition = scrollTopPosition - (scrollContainerDOMRect.top - nodeTopPosition);

                } else if (nodeBottomPosition > scrollContainerDOMRect.bottom) {

                    scrollTopPosition = scrollTopPosition - (scrollContainerDOMRect.bottom - nodeBottomPosition);
                }

                // scroll the container and save the new scroll position
                scrollContainer.scrollTop(scrollTopPosition);
                scrollTopHidden.val(scrollTopPosition);
            }

            // Scroll the security model container horizontally to the position it was before a post
            if (scrollLeftHidden.val()) {

                scrollContainer.scrollLeft(scrollLeftHidden.val());
            }

            // Hook up scroll evet to save off the scroll position so that we can scroll to it after a post
            scrollContainer.scroll(_.debounce(function () {
                scrollTopHidden.val(scrollContainer.scrollTop());
                scrollLeftHidden.val(scrollContainer.scrollLeft());
            }, 200));

            // reload the security model when a new site is selected
            form.js(jsSelectors.siteSelect).change(function () {

                form.js(jsSelectors.loadingSpinner).show();

                securityModelControl.loadSecurityModel($(this).val()).always(function () {
                    form.js(jsSelectors.loadingSpinner).hide();
                });
            });

            // submit the form for delete
            securityModelControl.onNodeDeleteConfirmed(function () {

                form.attr("action", formActionUrls.delete);
                form.submit();
            });

            // submit the form for add
            securityModelControl.onNodeAddConfirmed(function (resourceName) {

                form.js(jsSelectors.resourceNameHidden).val(resourceName);

                form.attr("action", formActionUrls.add);
                form.submit();
            });

            // submit the form for download
            securityModelControl.onNodeDownloadConfirmed(function () {

                form.attr("action", formActionUrls.output);
                form.submit();
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);